var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg01D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    strokeWidth: 1.5,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_503_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 5.5,
    stroke: "#facc15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19.5V23",
    stroke: "#facc15",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 12H23",
    stroke: "#facc15",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5V1",
    stroke: "#facc15",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 12H4.5",
    stroke: "#facc15",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6.5L20 3.5",
    stroke: "#facc15",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6.5L4 3.5",
    stroke: "#facc15",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 17.5L20 20.5",
    stroke: "#facc15",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 17.5L4 20.5",
    stroke: "#facc15",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_503_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01D);
export default __webpack_public_path__ + "static/media/01d.5fcb7ee10b73103df01a98ba28335795.svg";
export { ForwardRef as ReactComponent };